import { gql } from '@apollo/client';
import { imageCardFragment } from '../ImageCard/ImageCard.fragment';

export const threeCardBlockFragment = gql`
  fragment threeCardBlock on ThreeCardBlock {
    __typename
    sys {
      ...sys
    }
    tagline
    heading
    description
    cardsCollection(limit: 3) {
      items {
        ...imageCard
      }
    }
  }

  ${imageCardFragment}
`;
